import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';

import { getVideoId } from '../../../utils/helpers';

const opts = {
  height: '100%',
  width: '100%',
  // title: 'dialog',
  playerVars: {
    // https://developers.google.com/youtube/player_parameters
    autoplay: 0,
    playsinline: 1,
    // modestbranding: 1, Hides youtube logo
  },
};

const ReactYT = ({ className, videoSrcURL, playing }) => {
  const [player, setPlayer] = useState(null);

  const _onReady = event => {
    // access to player in all event handlers via event.target
    setPlayer(event.target);
  };

  useEffect(() => {
    if (playing && player) player.playVideo();
  }, [playing, player]);

  return (
    <YouTube
      containerClassName={('video', className)}
      videoId={getVideoId(videoSrcURL)}
      opts={opts}
      onReady={_onReady}
    />
  );
};

ReactYT.propTypes = {
  className: PropTypes.string,
  videoSrcURL: PropTypes.string.isRequired,
  playing: PropTypes.bool,
};

ReactYT.defaultProps = {
  className: null,
  playing: false,
};

export default ReactYT;
